import React from "react";
import { Actionable, Button, SheetContainer } from "@bookingcom/bui-react";
import { useUnifiedPriceTagPriceBreakdownController } from "./useUnifiedPriceTagPriceBreakdown.controller";
import { type UnifiedPriceTagPriceBreakdownProps } from "./UnifiedPriceTagPriceBreakdown";
import useRouteName from "../../../hooks/useRouteName";

export const UnifiedPriceTagPriceBreakdownMobile = ({
  priceBreakdownTrigger,
  priceBreakdownTriggerProps,
  priceBreakdownContent,
  priceBreakdownCloseAriaLabel,
  priceBreakdownOnOpen = () => {},
  priceBreakdownOnClose = () => {}
}: UnifiedPriceTagPriceBreakdownProps) => {
  const { contentTitle, closeAriaLabel, showPriceBreakdown, setShowPriceBreakdown } =
    useUnifiedPriceTagPriceBreakdownController();
  const routeName = useRouteName();

  if (!priceBreakdownTrigger) {
    return;
  }

  const handlePriceBreakdownClick = (e: React.SyntheticEvent) => {
    if (!!priceBreakdownContent) {
      e.stopPropagation();
      if (!showPriceBreakdown) {
        setShowPriceBreakdown(true);
        priceBreakdownOnOpen();
      }
    }
  };

  const priceStrikethroughIconAsButton = (
    <Button
      variant="tertiary-neutral"
      size="medium"
      {...priceBreakdownTriggerProps}
      onClick={handlePriceBreakdownClick}
    >
      {priceBreakdownTrigger}
    </Button>
  );

  return (
    <>
      {routeName.includes("flightdetails") ? (
        priceStrikethroughIconAsButton
      ) : (
        <Actionable onClick={handlePriceBreakdownClick} {...priceBreakdownTriggerProps} tagName="span">
          {priceBreakdownTrigger}
        </Actionable>
      )}
      {showPriceBreakdown && (
        <SheetContainer
          onCloseTrigger={() => {
            setShowPriceBreakdown(false);
            priceBreakdownOnClose();
          }}
          title={contentTitle}
          closeAriaLabel={priceBreakdownCloseAriaLabel || closeAriaLabel}
          active={true}
          attributes={{
            "data-testid": "upt_price_breakdown_content"
          }}
        >
          {priceBreakdownContent}
        </SheetContainer>
      )}
    </>
  );
};
